var map = {
	"./backward.png": 8630,
	"./forward.png": 6030,
	"./next.png": 6446,
	"./pause.png": 6879,
	"./play.png": 1447,
	"./prev.png": 8078,
	"./settings.png": 406,
	"./settings_active.png": 6765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1509;